import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-2 mx-auto pb-12" }
const _hoisted_2 = { class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-2 w-[620px] mx-auto" }
const _hoisted_3 = { class: "px-4 py-6 sm:p-8 mx-auto" }
const _hoisted_4 = {
  key: 0,
  class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
}
const _hoisted_5 = { class: "sm:col-span-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "First name", -1)
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "sm:col-span-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Last Name", -1)
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "sm:col-span-full" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Email", -1)
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = { class: "sm:col-span-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Role", -1)
const _hoisted_16 = { class: "mt-2 relative" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "absolute text-sm right-0 z-10 mt-1 w-full rounded-md bg-white border border-gray-300 shadow-md" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "sm:text-sm sm:col-span-full"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "sm:col-span-3 block font-medium leading-6 text-dark-blue" }, "Search School", -1)
const _hoisted_23 = { class: "col-span-full sm:w-96 sm:mx-auto mt-0 sm:mt-4 flex gap-x-10" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SchoolSearch = _resolveComponent("SchoolSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.userUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userUpdate.firstName) = $event)),
                    type: "text",
                    disabled: "",
                    placeholder: "First Name",
                    class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.userUpdate.firstName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userUpdate.lastName) = $event)),
                    type: "text",
                    disabled: "",
                    placeholder: "Last Name",
                    class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.userUpdate.lastName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userUpdate.email) = $event)),
                    type: "email",
                    disabled: "",
                    placeholder: "Email",
                    class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.userUpdate.email]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["stop"])),
                    class: "flex items-center justify-between w-full rounded-md border-0 py-1.5 px-2 text-dark-blue cursor-pointer shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.userUpdate.roles[0]), 1),
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(["h-4 w-4 transition-transform", { 'rotate-180': _ctx.isRoleDropdownOpen }]),
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, _hoisted_18, 2))
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.selectRole(role)),
                          class: "py-2 px-4 hover:bg-gray-100 cursor-pointer"
                        }, _toDisplayString(role), 9, _hoisted_20)
                      ]))
                    }), 256))
                  ], 512), [
                    [_vShow, _ctx.isRoleDropdownOpen]
                  ])
                ])
              ]),
              (_ctx.userUpdate.roles[0] === 'SchoolAdmin' && _ctx.schools.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_SchoolSearch, {
                      style: '',
                      school: _ctx.user.school,
                      "filtered-schools": _ctx.filteredSchools,
                      onSchoolChange: _cache[4] || (_cache[4] = (selectedSchool) => _ctx.selectSchool(selectedSchool)),
                      onInput: _ctx.filterSchools
                    }, null, 8, ["school", "filtered-schools", "onInput"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('back'))),
                  class: "bg-dark-blue text-white py-2.5 w-full rounded-md shadow-md"
                }, " Back "),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateUserRole(_ctx.userUpdate))),
                  disabled: !_ctx.isUpdated,
                  class: _normalizeClass([!_ctx.isUpdated ? 'bg-gray-500' : 'bg-green', "text-white py-2.5 w-full rounded-md shadow-md"])
                }, " Save Changes ", 10, _hoisted_24)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}